// The pure half of the hex-grid layers (ui-map-interface.md §4.3, R456).
// It imports no renderer, so the vitest reads it without an engine, exactly as
// `heatmap-ramp.ts` does for the heat ramp.

/**
 * Every owned cell index, per faction id, in ascending index order.
 *
 * Owner 0 is unclaimed water and gets no entry. A blocked cell is rock and
 * is never owned (world.ClaimDisc), so it is dropped as well — a stale
 * owners byte under a ridge must not draw a hex over the rock.
 *
 * The order is ascending because a Graphics path is rebuilt from it, and a
 * deterministic order keeps the drawn picture a function of `owners` alone.
 */
export function ownedCellsByFaction(
  owners: Uint8Array, blocked?: Uint8Array | null,
): Map<number, number[]> {
  const out = new Map<number, number[]>();
  for (let i = 0; i < owners.length; i++) {
    const f = owners[i];
    if (f === 0) continue;
    if (blocked && blocked[i]) continue;
    let list = out.get(f);
    if (!list) { list = []; out.set(f, list); }
    list.push(i);
  }
  return out;
}
